import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Layout,
  Radio,
  Row,
  Select,
  Space,
  Spin,
  Breadcrumb
} from "antd";
import "antd/dist/antd.min.css";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate, useParams,Link } from "react-router-dom";
import "../../styles/Main.scss";
import { authUserData } from "../../utils/Helper";
// import StepSider from "./StepSider";
import PhoneInput from "react-phone-input-2";
import { getRequest, patchRequest, postRequest } from "../../axios";
import { ReactComponent as ZipCode } from "../../image/ZipCode.svg";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import InputField from "../../common/htmlComponents/InputField";
const onChange = (e) => {
  console.log(`checked = ${e.target.checked}`);
};
const { Content } = Layout;
const handleChange = (value) => {
  console.log(`selected ${value}`);
};
const PRApprovalHierarchy = () => {
  const navigate = useNavigate();
  const [siteEmployee, setSiteEmployee] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  // const [showCheckbox, setShowCheckbox] = useState(true);
  // const [addedCompanyId, setAddedCompanyId] = useState(null);
  const { t } = useTranslation();
  const { Option } = Select;
  const formRef = useRef();
  const { id } = useParams();
  const PRApprovalHierarchyId = id ? id : null;
  //console.log(PRApprovalHierarchyId, "idddd")
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const initialState = {
    address_master: "",
    address_master_id: null,
    pr_release_hierarchy: true,
    pr_second_release: false,
    pr_second_value_up_to: 0,
    pr_second_release_manager: null,
    pr_third_release: false,
    pr_third_value_up_to: 0,
    pr_third_release_manager: null,
    pr_fourth_release: false,
    pr_fourth_value_up_to: 0,
    pr_fourth_release_manager: null,
    pr_fifth_release: false,
    pr_fifth_value_up_to: 0,
    pr_fifth_release_manager: null,
    site_name: "",
  };
  const [state, setState] = useState(initialState);
  const [releaseManager, setReleaseManager] = useState([]);
  const [releaseManager4, setReleaseManager4] = useState([]);
  const [releaseManager5, setReleaseManager5] = useState([]);
  const [releaseManagers, setReleaseManagers] = useState([]);
  // const [selectedReleaseManager, setSelectedReleaseManager] = useState(null);
  // const [selectedReleaseManagers, setSelectedReleaseManagers] = useState(null);
  // const [selectedReleaseManagers4, setSelectedReleaseManagers4] =
  //   useState(null);
  // const [selectedReleaseManagers5, setSelectedReleaseManagers5] =
  //   useState(null);
  const [designation1, setDesignation1] = useState("");
  const [phone1, setPhone1] = useState("");
  const [designation2, setDesignation2] = useState("");
  const [phone2, setPhone2] = useState("");
  const [designation3, setDesignation3] = useState("");
  const [phone3, setPhone3] = useState("");
  const [designation4, setDesignation4] = useState("");
  const [phone4, setPhone4] = useState("");
  const [selectedReleaseManager, setSelectedReleaseManager] = useState([]);
  const [selectedThirdReleaseManager, setSelectedThirdReleaseManager] =
    useState([]);
  const [formValid, setFormValid] = useState(false);
  // useEffect(() => {
  //     PRApprovalHierarchyGetByIds();
  // }, [PRApprovalHierarchyId, t]);

  const [role1, setRole1] = useState([]);
  const [role2, setRole2] = useState([]);
  const [role3, setRole3] = useState([]);
  const [role4, setRole4] = useState([]);

  useEffect(() => {
    const PRApprovalHierarchyGetByIds = async () => {
      setapiLoading(true);
      try {
        let apiResponse = await getRequest(
          "pr-release/" + PRApprovalHierarchyId
        );
        if (
          apiResponse.status === 200 &&
          apiResponse.data &&
          apiResponse.data.message
        ) {
          const responseData = apiResponse.data.message;
          setState((prevState) => ({
            ...prevState,
            // address_master: responseData.address_master,
            address_master: responseData.address,
            address_master_id: responseData.address_master,
            company: responseData.company,
            id: responseData.id,
            pr_release_hierarchy: responseData.pr_release_hierarchy,
            pr_second_release: responseData.pr_second_release,
            editableFlag: responseData.pr_second_release,
            pr_second_value_up_to: responseData.pr_second_value_up_to,
            // pr_second_release_manager:
            //   responseData.pr_second_release_manager.id,
            pr_second_release_manager:
              responseData?.pr_second_release_manager?.id || null,
            pr_third_release: responseData.pr_third_release,
            editableFlag2: responseData.pr_third_release,
            pr_third_value_up_to: responseData.pr_third_value_up_to,
            pr_third_release_manager:
              responseData?.pr_third_release_manager?.id || null,
            pr_fourth_release: responseData.pr_fourth_release,
            editableFlag4: responseData.pr_fourth_release,
            pr_fourth_value_up_to: responseData.pr_fourth_value_up_to,
            pr_fourth_release_manager:
              responseData?.pr_fourth_release_manager?.id || null,
            pr_fifth_release: responseData.pr_fifth_release,
            editableFlag5: responseData.pr_fifth_release,
            pr_fifth_value_up_to: responseData.pr_fifth_value_up_to,
            pr_fifth_release_manager:
              responseData?.pr_fifth_release_manager?.id || null,
            site_name: responseData.address,
          }));

          setSelectedReleaseManager([
            {
              pr_second_release_manager:
                responseData?.pr_second_release_manager?.id,
            },
            {
              pr_third_release_manager:
                responseData?.pr_third_release_manager?.id,
            },
            {
              pr_fourth_release_manager:
                responseData?.pr_fourth_release_manager?.id,
            },
            {
              pr_fifth_release_manager:
                responseData?.pr_fifth_release_manager?.id,
            },
          ]);
          setSelectedThirdReleaseManager([
            {
              pr_second_release_manager:
                responseData?.pr_second_release_manager?.id,
            },
            {
              pr_third_release_manager:
                responseData?.pr_third_release_manager?.id,
            },
            {
              pr_fourth_release_manager:
                responseData?.pr_fourth_release_manager?.id,
            },
            {
              pr_fifth_release_manager:
                responseData?.pr_fifth_release_manager?.id,
            },
          ]);

          // setSelectedReleaseManager(
          //   responseData?.pr_second_release_manager?.id || null
          // );
          // setSelectedReleaseManagers(
          //   responseData?.pr_third_release_manager?.id || null
          // );
          // setSelectedReleaseManagers4(
          //   responseData?.pr_fourth_release_manager?.id || null
          // );
          // setSelectedReleaseManagers5(
          //   responseData?.pr_fifth_release_manager?.id || null
          // );

          formRef.current.setFieldsValue({
            ...responseData,
            pr_second_release_manager:
              responseData?.pr_second_release_manager?.id || "",
            designation1: responseData?.pr_second_release_manager?.role || "",
            phone1: responseData?.pr_second_release_manager?.phone || "",
            pr_third_release_manager:
              responseData?.pr_third_release_manager?.id || "",
            designation2: responseData?.pr_third_release_manager?.role || "",
            phone2: responseData?.pr_third_release_manager?.phone || "",
            pr_fourth_release_manager:
              responseData?.pr_fourth_release_manager?.id || "",
            designation3: responseData?.pr_fourth_release_manager?.role || "",
            phone3: responseData?.pr_fourth_release_manager?.phone || "",
            pr_fifth_release_manager:
              responseData?.pr_fifth_release_manager?.id || "",
            designation4: responseData?.pr_fifth_release_manager?.role || "",
            phone4: responseData?.pr_fifth_release_manager?.phone || "",
            address_master: responseData?.address,
            // role1: responseData?.pr_second_release_manager?.phone || "",
            // pr_third_release_manager:
            //   responseData?.pr_third_release_manager?.id || "",
            // designation2:
            //   responseData?.pr_third_release_manager?.designation || "",
            // role2: responseData?.pr_third_release_manager?.phone || "",
            // pr_fourth_release_manager:
            //   responseData?.pr_fourth_release_manager?.id || "",
            // designation3:
            //   responseData?.pr_fourth_release_manager?.designation || "",
            // role3: responseData?.pr_fourth_release_manager?.phone || "",
            // pr_fifth_release_manager:
            //   responseData?.pr_fifth_release_manager?.id || "",
            // designation4:
            //   responseData?.pr_fifth_release_manager?.designation || "",
            // role4: responseData?.pr_fifth_release_manager?.phone || "",
          });
          console.log("responseData", responseData);

          setRole1(responseData?.pr_second_release_manager?.role);
          setRole2(responseData?.pr_third_release_manager?.role);
          setRole3(responseData?.pr_fourth_release_manager?.role);
          setRole4(responseData?.pr_fifth_release_manager?.role);

          setSiteSelected(true);
          setapiLoading(false);
        }
      } catch (error) {
        // ErrorNotificationMsg(t("error_in_prapproval_hierarchy"));
        setapiLoading(false);
      }
    };
    if (PRApprovalHierarchyId !== null) {
      PRApprovalHierarchyGetByIds();
    }
  }, [PRApprovalHierarchyId, t]);

  console.log("statefddddr ", role1);

  useEffect(() => {
    getCurrency();
  }, []);
  const getCurrency = async (data) => {
    await getRequest(
      "business-settings/get-currency-by-business-setting/",
      data
    ).then((response) => {
      setCurrencySymbol(response.data.data);
    });
  };

  useEffect(() => {
    getReleaseManager();
  }, [selectedReleaseManager]);

  const getReleaseManager = async (data) => {
    try {
      //const response = await getRequest("employee/employees-by-company/", data);
      const response = await getRequest(
        "pr-release/get-pr-release-manager/",
        data
      );
      const releaseManagerData = response.data.results.data;

      const selectedManagerIds = selectedReleaseManager.map((manager) => {
        return {
          second: manager.pr_second_release_manager,
          third: manager.pr_third_release_manager,
          fourth: manager.pr_fourth_release_manager,
          fifth: manager.pr_fifth_release_manager,
        };
      });

      const filteredManagers = releaseManagerData.filter((manager) => {
        return selectedManagerIds.every((selectedIds) => {
          return Object.values(selectedIds).every((selectedId) => {
            return selectedId !== manager.user_id;
          });
        });
      });

      setReleaseManager(filteredManagers);
      setReleaseManagers(filteredManagers);
      setReleaseManager4(filteredManagers);
      setReleaseManager5(filteredManagers);
    } catch (error) {
      ErrorNotificationMsg(t("error_in_release_manager"));
    }
  };
  const [siteSelected, setSiteSelected] = useState(false);
  const handleSiteChange = (values) => {
    setState({ ...state, address_master_id: values });
    setSiteSelected(!!values);
  };

  useEffect(() => {
    getPincode();
  }, []);

  const getPincode = async (data) => {
    await getRequest(`employee/site-by-company/`, data).then((response) => {
      setSiteEmployee(response.data.results.data);
    });
  };

  const handleSubmit = async () => {
    const payload = {
      company: CompanyId,
      address_master: state.address_master_id,
      pr_release_hierarchy: state.pr_release_hierarchy,
      pr_second_release: state.pr_second_release,
      pr_second_value_up_to: state.pr_second_value_up_to,
      pr_second_release_manager: state.pr_second_release_manager,
      pr_third_release: state.pr_third_release,
      pr_third_value_up_to: state.pr_third_value_up_to,
      pr_third_release_manager: state.pr_third_release_manager,
      pr_fourth_release: state.pr_fourth_release,
      pr_fourth_value_up_to: state.pr_fourth_value_up_to,
      pr_fourth_release_manager: state.pr_fourth_release_manager,
      pr_fifth_release: state.pr_fifth_release,
      pr_fifth_value_up_to: state.pr_fifth_value_up_to,
      pr_fifth_release_manager: state.pr_fifth_release_manager,
    };
    try {
      setBtnLoading(true);
      let response;
      if (PRApprovalHierarchyId === null) {
        //(POST request)
        response = await postRequest("pr-release/", payload);
      } else {
        // (PATCH request)
        response = await patchRequest(
          `pr-release/${PRApprovalHierarchyId}/`,
          // `pr-release/${state.address_master}/`,

          payload
        );
      }
      if (response.data.success) {
        // setAddedCompanyId(response.data.data.id);
        SuccessNotificationMsg(
          PRApprovalHierarchyId
            ? t("pr_approval_hierarchy_updated_successfully")
            : t("pr_approval_hierarchy_added_successfully")
        );
        setState(initialState);
        formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        navigate("/pr-approval-heirarchy-list");
      }
    } catch (error) {
      // ErrorNotificationMsg(
      //   PRApprovalHierarchyId
      //     ? t("pr_approval_hierarchy_updated_successfully")
      //     : t("pr_approval_hierarchy_added_successfully")
      // );
      setBtnLoading(false);
    }
  };

  const handlePoReleaseChange = (name, value) => {
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if (state.pr_second_release && value !== 0) {
      setFormValid(true);
    } else {
      setFormValid(false);
    }
  };

  const handleSelectChangereleaseManager = (name, value) => {
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    const selectedValues = value;

    const newValue = { [name]: value };

    const index = selectedReleaseManager.findIndex((item) =>
      Object.prototype.hasOwnProperty.call(item, name)
    );

    if (index !== -1) {
      const updatedState = [...selectedReleaseManager];
      updatedState[index] = newValue;
      setSelectedReleaseManager(updatedState);
      setSelectedThirdReleaseManager(updatedState);
    } else {
      setSelectedReleaseManager([...selectedReleaseManager, newValue]);
      setSelectedThirdReleaseManager([...selectedReleaseManager, newValue]);
    }

    const manager = releaseManagers.find(
      (manager) => manager.user_id === selectedValues
    );

    if (manager) {
      setDesignation1(manager.designation);
      setPhone1(manager.phone);
      setRole1(manager.role);
      formRef.current.setFieldsValue({
        designation1: manager?.designation?.toUpperCase(),
      });
      formRef.current.setFieldsValue({
        phone1: manager?.phone ? manager?.phone : "",
      });
      formRef.current.setFieldsValue({
        role1: manager?.role ? manager?.role : "",
      });
    }
  };
  const editableFlagSecondPRRelease =
    state.pr_second_release &&
    state.pr_second_release_manager &&
    state.pr_second_value_up_to &&
    state.pr_second_value_up_to !== 0;

  const editableFlagThirdPRRelease =
    state.pr_third_release &&
    state.pr_third_release_manager &&
    state.pr_third_value_up_to &&
    state.pr_third_value_up_to !== 0;

  const editableFlagFourthPRRelease =
    state.pr_fourth_release &&
    state.pr_fourth_release_manager &&
    state.pr_fourth_value_up_to &&
    state.pr_fourth_value_up_to !== 0;

  const clearValues = () => {
    setState((prevState) => ({
      ...prevState,
      pr_third_value_up_to: 0,
      pr_third_release_manager: null,
      pr_fourth_value_up_to: 0,
      pr_fourth_release_manager: null,
      pr_fifth_value_up_to: 0,
      pr_fifth_release_manager: null,
    }));
  };

  const handleSelectChangereleaseManagers = (name, value) => {
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    const selectedValues = value;

    const newValue = { [name]: value };

    const index = selectedReleaseManager.findIndex((item) =>
      Object.prototype.hasOwnProperty.call(item, name)
    );

    if (index !== -1) {
      const updatedState = [...selectedReleaseManager];
      updatedState[index] = newValue;
      setSelectedReleaseManager(updatedState);
    } else {
      setSelectedReleaseManager([...selectedReleaseManager, newValue]);
    }

    const manager = releaseManagers.find(
      (manager) => manager.user_id === selectedValues
    );
    if (manager) {
      console.log("managercx", manager);

      setDesignation2(manager.designation);
      setPhone2(manager.phone);
      formRef.current.setFieldsValue({
        designation2: manager?.designation?.toUpperCase(),
      });
      // setRole2(manager?.pr_second_release_manager?.role )
      setRole2(manager?.role);
      formRef.current.setFieldsValue({
        phone2: manager?.phone ? manager?.phone : "",
      });
      formRef.current.setFieldsValue({
        role2: manager?.role ? manager?.role : "",
      });
    }
  };

  const handleSelectChangereleaseManagers4 = (name, value) => {
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    const selectedValues = value;

    const newValue = { [name]: value };

    const index = selectedReleaseManager.findIndex((item) =>
      Object.prototype.hasOwnProperty.call(item, name)
    );

    if (index !== -1) {
      const updatedState = [...selectedReleaseManager];
      updatedState[index] = newValue;
      setSelectedReleaseManager(updatedState);
      setSelectedThirdReleaseManager(updatedState);
    } else {
      setSelectedReleaseManager([...selectedReleaseManager, newValue]);
      setSelectedThirdReleaseManager([...selectedReleaseManager, newValue]);
    }

    const manager = releaseManagers.find(
      (manager) => manager.user_id === selectedValues
    );
    if (manager) {
      setDesignation3(manager.designation);
      setPhone3(manager.phone);
      formRef.current.setFieldsValue({
        designation3: manager?.designation?.toUpperCase(),
      });
      setRole3(manager?.role);
      formRef.current.setFieldsValue({
        phone3: manager?.phone ? manager?.phone : "",
      });
      formRef.current.setFieldsValue({
        role3: manager?.role ? manager?.role : "",
      });
    }
  };

  const handleSelectChangereleaseManagers5 = (name, value) => {
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    const selectedValues = value;

    const newValue = { [name]: value };

    const index = selectedReleaseManager.findIndex((item) =>
      Object.prototype.hasOwnProperty.call(item, name)
    );

    if (index !== -1) {
      const updatedState = [...selectedReleaseManager];
      updatedState[index] = newValue;
      setSelectedReleaseManager(updatedState);
      setSelectedThirdReleaseManager(updatedState);
    } else {
      setSelectedReleaseManager([...selectedReleaseManager, newValue]);
      setSelectedThirdReleaseManager([...selectedReleaseManager, newValue]);
    }

    const manager = releaseManagers.find(
      (manager) => manager.user_id === selectedValues
    );
    if (manager) {
      setDesignation4(manager.designation);
      setPhone4(manager.phone);
      formRef.current.setFieldsValue({
        designation4: manager?.designation?.toUpperCase(),
      });
      setRole4(manager?.role);

      formRef.current.setFieldsValue({
        phone4: manager?.phone ? manager?.phone : "",
      });
      formRef.current.setFieldsValue({
        role4: manager?.role ? manager?.role : "",
      });
    }
  };

  const handleOptionChangehierarchy = (name, value) => {
    setState({ ...state, [name]: value });

    if (name === "pr_release_hierarchy") {
      if (state.pr_second_release && value !== 0) {
        setFormValid(true);
      } else {
        setFormValid(false);
      }
      // setShowCheckbox(value === true);
    }
    if (value === false) {
      setState((prevState) => ({
        ...prevState,
        editableFlag: false,
        editableFlag2: false,
        editableFlag4: false,
        editableFlag5: false,
        pr_second_release: false,
        pr_second_value_up_to: 0,
        pr_second_release_manager: null,
        pr_third_release: false,
        pr_third_value_up_to: 0,
        pr_third_release_manager: null,
        pr_fourth_release: false,
        pr_fourth_value_up_to: 0,
        pr_fourth_release_manager: null,
        pr_fifth_release: false,
        pr_fifth_value_up_to: 0,
        pr_fifth_release_manager: null,
      }));

      setFormValid(true);
      setRole1([]);
      setRole2([]);
      setRole3([]);
      setRole4([]);
      setSelectedReleaseManager([]);
      // if (state.pr_second_release && value !== 0) {
      //   setFormValid(false);
      // } else {
      //   setFormValid(true);
      // }
      const defaultCountryCode = "+91";
      formRef.current.setFieldsValue({
        pr_second_release: false,
        pr_second_value_up_to: "",
        pr_second_release_manager: null,
        pr_third_release: false,
        pr_third_value_up_to: "",
        pr_third_release_manager: null,
        pr_fourth_release: false,
        pr_fourth_value_up_to: "",
        pr_fourth_release_manager: null,
        pr_fifth_release: false,
        pr_fifth_value_up_to: "",
        pr_fifth_release_manager: null,
        phone1: defaultCountryCode,
        designation1: null,
        phone2: defaultCountryCode,
        designation2: null,
        phone3: defaultCountryCode,
        designation3: null,
        phone4: defaultCountryCode,
        designation4: null,
      });
    }
  };

  const handleCheckBox = (fieldName, value, id) => {
    setState((prevState) => ({
      ...prevState,
      [fieldName]: value, // Update the state based on the checkbox change
      editableFlag: value, // Assuming editableFlag also depends on the checkbox
    }));

    if (!value) {
      setState((prevState) => ({
        ...prevState,
        editableFlag: false,
        editableFlag2: false,
        editableFlag4: false,
        editableFlag5: false,
        pr_second_release: false,
        pr_second_value_up_to: 0,
        pr_second_release_manager: null,
        pr_third_release: false,
        pr_third_value_up_to: 0,
        pr_third_release_manager: null,
        pr_fourth_release: false,
        pr_fourth_value_up_to: 0,
        pr_fourth_release_manager: null,
        pr_fifth_release: false,
        pr_fifth_value_up_to: 0,
        pr_fifth_release_manager: null,
      }));

      // setFormValid(true);

      const defaultCountryCode = "+91";
      formRef.current.setFieldsValue({
        pr_second_release: false,
        pr_second_value_up_to: "",
        pr_second_release_manager: null,
        pr_third_release: false,
        pr_third_value_up_to: "",
        pr_third_release_manager: null,
        pr_fourth_release: false,
        pr_fourth_value_up_to: "",
        pr_fourth_release_manager: null,
        pr_fifth_release: false,
        pr_fifth_value_up_to: "",
        pr_fifth_release_manager: null,
        phone1: defaultCountryCode,
        designation1: null,
        phone2: defaultCountryCode,
        designation2: null,
        phone3: defaultCountryCode,
        designation3: null,
        phone4: defaultCountryCode,
        designation4: null,
      });
      setRole1([]);
      setRole2([]);
      setRole3([]);
      setRole4([]);

      setSelectedReleaseManager((prevState) => {
        const newRelease = [...prevState];
        newRelease.length = 0;
        return newRelease;
      });
    }
  };

  const handleSecondReleaseCheckbox = (value) => {
    if (value) {
      setState((prevState) => ({
        ...prevState,
        editableFlag2: false,
        editableFlag4: false,
        editableFlag5: false,
        pr_third_release: false,
        pr_third_value_up_to: 0,
        pr_third_release_manager: null,
        pr_fourth_release: false,
        pr_fourth_value_up_to: 0,
        pr_fourth_release_manager: null,
        pr_fifth_release: false,
        pr_fifth_value_up_to: 0,
        pr_fifth_release_manager: null,
      }));
    }
    setSelectedReleaseManager([]);
    const defaultCountryCode = "+91";
    formRef.current.setFieldsValue({
      pr_third_release: false,
      pr_third_value_up_to: "",
      pr_third_release_manager: null,
      pr_fourth_release: false,
      pr_fourth_value_up_to: "",
      pr_fourth_release_manager: null,
      pr_fifth_release: false,
      pr_fifth_value_up_to: "",
      pr_fifth_release_manager: null,
      phone2: defaultCountryCode,
      designation2: null,
      phone3: defaultCountryCode,
      designation3: null,
      phone4: defaultCountryCode,
      designation4: null,
    });

    if (formRef.current) {
      formRef.current.submit(); // Or use another method to sync data
    }
  };

  const getFieldToClear = (fieldName) => {
    switch (fieldName) {
      case "pr_second_release":
        return ["pr_second_value_up_to", "pr_second_release_manager"];
      case "pr_third_release":
        return ["pr_third_value_up_to", "pr_third_release_manager"];
      case "pr_fourth_release":
        return ["pr_fourth_value_up_to", "pr_fourth_release_manager"];
      case "pr_fifth_release":
        return ["pr_fifth_value_up_to", "pr_fifth_release_manager"];
      default:
        return [];
    }
  };

  const handleCheckBox2 = (fieldName, value, id) => {
    setState((prevState) => ({
      ...prevState,
      [fieldName]: value, // Update the state based on the checkbox change
      editableFlag2: value, // Assuming editableFlag also depends on the checkbox
    }));

    if (!value) {
      setState((prevState) => ({
        ...prevState,
        editableFlag2: false,
        editableFlag4: false,
        editableFlag5: false,
        pr_third_release: false,
        pr_third_value_up_to: 0,
        pr_third_release_manager: null,
        pr_fourth_release: false,
        pr_fourth_value_up_to: 0,
        pr_fourth_release_manager: null,
        pr_fifth_release: false,
        pr_fifth_value_up_to: 0,
        pr_fifth_release_manager: null,
      }));

      // setFormValid(true);

      const defaultCountryCode = "+91";
      formRef.current.setFieldsValue({
        pr_third_release: false,
        pr_third_value_up_to: "",
        pr_third_release_manager: null,
        pr_fourth_release: false,
        pr_fourth_value_up_to: "",
        pr_fourth_release_manager: null,
        pr_fifth_release: false,
        pr_fifth_value_up_to: "",
        pr_fifth_release_manager: null,
        phone2: defaultCountryCode,
        designation2: null,
        phone3: defaultCountryCode,
        designation3: null,
        phone4: defaultCountryCode,
        designation4: null,
      });
      setRole2([]);
      setRole3([]);
      setRole4([]);
      setSelectedReleaseManager((prevState) => {
        const newRelease = [...prevState];
        newRelease.length = 1;
        return newRelease;
      });
    }
  };

  const handleThirdReleaseCheckbox = (value) => {
    if (value) {
      setState((prevState) => ({
        ...prevState,
        editableFlag3: false,
        editableFlag4: false,
        editableFlag5: false,
        pr_fourth_release: false,
        pr_fourth_value_up_to: 0,
        pr_fourth_release_manager: "",
        pr_fifth_release: false,
        pr_fifth_value_up_to: 0,
        pr_fifth_release_manager: "",
      }));
    }
    setSelectedReleaseManager([]);
    // setSelectedThirdReleaseManager([]);
    const defaultCountryCode = "+91";
    formRef.current.setFieldsValue({
      pr_fourth_release: false,
      pr_fourth_value_up_to: "",
      pr_fourth_release_manager: null,
      pr_fifth_release: false,
      pr_fifth_value_up_to: "",
      pr_fifth_release_manager: null,
      phone3: defaultCountryCode,
      designation3: null,
      phone4: defaultCountryCode,
      designation4: null,
    });
  };
  const handleCheckBox4 = (fieldName, value, id) => {
    setState((prevState) => ({
      ...prevState,
      [fieldName]: value, // Update the state based on the checkbox change
      editableFlag4: value, // Assuming editableFlag also depends on the checkbox
    }));

    if (!value) {
      setState((prevState) => ({
        ...prevState,
        editableFlag4: false,
        editableFlag5: false,
        pr_fourth_release: false,
        pr_fourth_value_up_to: 0,
        pr_fourth_release_manager: null,
        pr_fifth_release: false,
        pr_fifth_value_up_to: 0,
        pr_fifth_release_manager: null,
      }));

      // setFormValid(true);

      const defaultCountryCode = "+91";
      formRef.current.setFieldsValue({
        pr_fourth_release: false,
        pr_fourth_value_up_to: "",
        pr_fourth_release_manager: null,
        pr_fifth_release: false,
        pr_fifth_value_up_to: "",
        pr_fifth_release_manager: null,
        phone3: defaultCountryCode,
        designation3: null,
        phone4: defaultCountryCode,
        designation4: null,
      });
      setRole3([]);
      setRole4([]);
      setSelectedReleaseManager((prevState) => {
        const newRelease = [...prevState];
        newRelease.length = 2;
        return newRelease;
      });
    }
  };

  const setSelectedForthReleaseManager = (value) => {
    if (value) {
      setState((prevState) => ({
        ...prevState,
        editableFlag5: false,
        pr_fifth_release: false,
        pr_fifth_value_up_to: 0,
        pr_fifth_release_manager: null,
      }));
    }
    // setSelectedReleaseManager([]);
    const defaultCountryCode = "+91";
    formRef.current.setFieldsValue({
      pr_fifth_release: false,
      pr_fifth_value_up_to: "",
      pr_fifth_release_manager: null,
      phone4: defaultCountryCode,
      designation4: null,
    });
  };

  const handleCheckBox5 = (fieldName, value, id) => {
    setState((prevState) => ({
      ...prevState,
      [fieldName]: value, // Update the state based on the checkbox change
      editableFlag5: value, // Assuming editableFlag also depends on the checkbox
    }));

    if (!value) {
      setState((prevState) => ({
        ...prevState,
        editableFlag5: false,
        pr_fifth_release: false,
        pr_fifth_value_up_to: 0,
        pr_fifth_release_manager: null,
      }));

      // setFormValid(true);

      const defaultCountryCode = "+91";
      formRef.current.setFieldsValue({
        pr_fifth_release: false,
        pr_fifth_value_up_to: "",
        pr_fifth_release_manager: null,
        phone3: defaultCountryCode,
        designation3: null,
        phone4: defaultCountryCode,
        designation4: null,
      });
      setRole4([]);
      setSelectedReleaseManager((prevState) => {
        const newRelease = [...prevState];
        newRelease.length = 3;
        return newRelease;
      });
    }
  };

  //console.log("release", releaseManager);
  //console.log("sele", selectedReleaseManager);
  const [arrow, setArrow] = useState("Show");
  // const mergedArrow = useMemo(() => {
  //   if (arrow === 'Hide') {
  //     return false;
  //   }
  //   if (arrow === 'Show') {
  //     return true;
  //   }
  //   return {
  //     pointAtCenter: true,
  //   };
  // }, [arrow]);
  const colors = ["#094E8F"];
  console.log("siteEmployeefdd", siteEmployee, "state", state);

  return (
    <>
     <div className="ListingTopBar">
            <div className="pagenamewrap">
              <div className="pagename">
              
                <h3>PR Release Hierarchy</h3>
    
                <Breadcrumb className="Breadcrumb-Sec">
                  <Breadcrumb.Item>
                    <Link to="/dashboard">Dashboard</Link>
                  </Breadcrumb.Item>
    
                  <Breadcrumb.Item>PR Release Hierarchy</Breadcrumb.Item>
                </Breadcrumb>
                </div>
             
              
            </div>
          </div>
       
              <section className="grid-sec FormSection Container">
                <div className="FormBody" style={{ padding: "0" }}>
                 
            <Form onFinish={handleSubmit} autoComplete="off" ref={formRef} className="stepscontentwrap">
                <div className="stepsContent">
                  <Spin spinning={apiLoading}>
                  <div className="formwrapper">
                    <div className="formrowsection edithirachy">
                      <Row gutter={16}>
                        <Col xs={24} sm={24} md={12} xl={6}>
                          <Form.Item
                            name="address_master"
                            label="Site"
                            rules={[
                              {
                                required: true,
                                message: <Trans>Please select site</Trans>,
                              },
                            ]}
                          >
                            <Select
                              showArrow
                              showSearch
                              placeholder="Enter Site Name"
                              optionFilterProp="children"
                              onChange={handleSiteChange}
                              value={state.site_name}
                            >
                              {siteEmployee &&
                                siteEmployee.length > 0 &&
                                siteEmployee
                                  ?.filter((i) => i.is_selected !== true)
                                  ?.map((item) => (
                                    <Select.Option
                                      key={item.site_id}
                                      value={item.site_id}
                                    >
                                      {item.site_name}
                                    </Select.Option>
                                  ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                    <div className="hirachytable">
                      <div className="radioheading">
                        <Row gutter={16}>
                          <Col
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={24}
                            className="TextFeild gutter-row"
                          >
                            <Space align="center">
                              <label className="lbl">
                                PR Release Hierarchy
                              </label>

                              <Form.Item
                                className="radioitem radio2"
                                name="pr_release_hierarchy"
                                label=""
                                initialValue={true}
                              >
                                <Radio.Group
                                  onChange={(e) =>
                                    handleOptionChangehierarchy(
                                      "pr_release_hierarchy",
                                      e.target.value
                                    )
                                  }
                                  value={state.pr_release_hierarchy}
                                  disabled={!siteSelected}
                                >
                                  <Radio value={true}>Yes</Radio>
                                  <Radio value={false}>No</Radio>
                                </Radio.Group>
                              </Form.Item>
                            </Space>
                          </Col>
                        </Row>
                      </div>
                      <div style={{overflowX:'auto'}}>
                        <div style={{minWidth:'1111px'}}>
                        {state.pr_release_hierarchy && (
                          <>
                            <Row gutter={16}>
                              <Col span={4}></Col>
                              <Col span={4} className="TextFeild gutter-row">
                                <label className="th">PR Value Up To (₹)</label>
                              </Col>
                              <Col span={4} className="TextFeild gutter-row">
                                <label className="th">Release Manager</label>
                              </Col>
                              {/* <Col span={5} className="TextFeild gutter-row">
                                <label className="th">Designation</label>
                              </Col> */}
                              <Col span={5} className="TextFeild gutter-row">
                                <label className="th">Mobile Number</label>
                              </Col>
                              <Col span={5} className="TextFeild gutter-row">
                                <label className="th">Role</label>
                              </Col>
                            </Row>

                            <Row gutter={16}>
                              <Col span={4}>
                                {/* <Checkbox>
                            Second Release
                          </Checkbox> */}
                                <Checkbox
                                  checked={state.pr_second_release} // Set the checked status based on state
                                  disabled={!siteSelected}
                                  onChange={(e) => {
                                    handleCheckBox(
                                      "pr_second_release",
                                      e.target.checked,
                                      state.pr_second_release_manager
                                    );
                                    // handleSecondReleaseCheckbox(e);
                                  }}
                                >
                                  Second Release
                                </Checkbox>
                              </Col>
                              <Col span={4} className="TextFeild gutter-row">
                                <Form.Item
                                  name={`pr_second_value_up_to`}
                                  rules={[
                                    {
                                      required: state.pr_second_release,
                                      message: (
                                        <Trans>
                                          {" "}
                                          Please Enter PR Second Value Up To
                                        </Trans>
                                      ),
                                      validator: (_, value) => {
                                        const parsedValue = parseFloat(value);
                                        if (state.pr_second_release) {
                                          // If checkbox is checked, don't allow 0
                                          if (
                                            !isNaN(parsedValue) &&
                                            parsedValue !== 0
                                          ) {
                                            return Promise.resolve();
                                          }
                                          return Promise.reject(
                                            new Error("Value cannot be 0")
                                          );
                                        } else {
                                          // If checkbox is unchecked, allow any value
                                          return Promise.resolve();
                                        }
                                      },
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="5,000"
                                    addonBefore={currencySymbol}
                                    type="number"
                                    value={state.pr_second_value_up_to}
                                    onChange={(e) =>
                                      handlePoReleaseChange(
                                        "pr_second_value_up_to",
                                        e.target.value
                                      )
                                    }
                                    disabled={!state.editableFlag}
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={4}>
                                <Form.Item
                                  name="pr_second_release_manager"
                                  prefix={<ZipCode />}
                                  rules={[
                                    {
                                      required: state.pr_second_release,
                                      message: (
                                        <Trans>
                                          {" "}
                                          Please Select PR Second Release
                                          Manager
                                        </Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <Select
                                    showArrow
                                    showSearch
                                    allowClear
                                    placeholder="Select Release Manager"
                                    value={state.pr_second_release_manager}
                                    onChange={(value) =>
                                      handleSelectChangereleaseManager(
                                        "pr_second_release_manager",
                                        value
                                      )
                                    }
                                    disabled={!state.editableFlag}
                                    optionFilterProp="children"
                                  >
                                    {releaseManager.map((manager) => (
                                      <option
                                        key={manager.user_id}
                                        value={manager.user_id}
                                        disabled={selectedReleaseManager?.includes(
                                          manager.user_id
                                        )}
                                      >
                                        {manager?.first_name
                                          ?.charAt(0)
                                          ?.toUpperCase() +
                                          manager?.first_name
                                            ?.slice(1)
                                            ?.toLowerCase()}
                                      </option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <>
                                {/* <Col span={5} className="TextFeild gutter-row">
                                  <Form.Item name="designation1">
                                    <Input
                                      placeholder="HOD"
                                      value={designation1}
                                      disabled
                                    />
                                  </Form.Item>
                                </Col> */}
                                <Col span={5} className="TextFeild gutter-row">
                                  <Form.Item name="phone1">
                                    <PhoneInput
                                      country={"in"}
                                      className="PhoneSection"
                                      value={phone1}
                                      inputProps={{ readOnly: true }}
                                      disabled
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={6} className="TextFeild gutter-row">
                                  {/* <Form.Item name="role"> */}
                                  <div className="verifywrap">
                                    <div>
                                      <Select
                                        mode="multiple"
                                        maxTagCount="responsive"
                                        style={{ width: "250px" }}
                                        placeholder="Role"
                                        // disabled
                                        value={role1}
                                        tagRender={({ label }) => (
                                          <span
                                            style={{
                                              padding: "4px 5px",
                                              background: "#f0f0f0",
                                              borderRadius: "4px",
                                              marginRight: "5px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            {label}
                                          </span>
                                        )}
                                      >
                                        {role1?.map((vendor) => (
                                          <Select.Option
                                            key={vendor}
                                            value={vendor}
                                          >
                                            {vendor}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </div>

                                    {/* <InputField
                                      name="role1"
                                      placeholder={t("Role")}
                                      // max={40}
                                      disabled
                                    /> */}
                                  </div>
                                  {/* </Form.Item> */}
                                </Col>
                              </>
                            </Row>
                            <Row gutter={16}>
                              <Col span={4}>
                                {/* <Checkbox>
                            Third Release
                          </Checkbox> */}
                                <Checkbox
                                  checked={state.pr_third_release} // Set the checked status based on state
                                  disabled={!editableFlagSecondPRRelease}
                                  onChange={(e) => {
                                    handleCheckBox2(
                                      "pr_third_release",
                                      e.target.checked,
                                      state.pr_third_release_manager
                                    );
                                    // handleThirdReleaseCheckbox(e)
                                  }}
                                >
                                  Third Release
                                </Checkbox>
                              </Col>
                              <Col span={4} className="TextFeild gutter-row">
                                <Form.Item
                                  name="pr_third_value_up_to"
                                  rules={[
                                    {
                                      required: state.pr_third_release,
                                      message: (
                                        <Trans>
                                          {" "}
                                          Please Enter PR Third Value Up To
                                        </Trans>
                                      ),
                                      validator: (_, value) => {
                                        const parsedValue = parseFloat(value);
                                        if (state.pr_third_release) {
                                          // If checkbox is checked, don't allow 0
                                          if (
                                            !isNaN(parsedValue) &&
                                            parsedValue !== 0
                                          ) {
                                            return Promise.resolve();
                                          }
                                          return Promise.reject(
                                            new Error("Value cannot be 0")
                                          );
                                        } else {
                                          // If checkbox is unchecked, allow any value
                                          return Promise.resolve();
                                        }
                                      },
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="5,000"
                                    addonBefore={currencySymbol}
                                    type="number"
                                    value={state.pr_third_value_up_to}
                                    onChange={(e) =>
                                      handlePoReleaseChange(
                                        "pr_third_value_up_to",
                                        e.target.value
                                      )
                                    }
                                    disabled={!state.editableFlag2}
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={4}>
                                <Form.Item
                                  name="pr_third_release_manager"
                                  prefix={<ZipCode />}
                                  rules={[
                                    {
                                      required: state.pr_third_release,
                                      message: (
                                        <Trans>
                                          {" "}
                                          Please Enter PR Third Release Manager
                                        </Trans>
                                      ),
                                    },
                                  ]}
                                  // rules={[
                                  //   {
                                  //     required: state?.editableFlag2,
                                  //     message: "Please select a Release Manager",
                                  //   },
                                  // ]}
                                >
                                  <Select
                                    showArrow
                                    showSearch
                                    allowClear
                                    placeholder="Select Release Manager"
                                    value={state.pr_third_release_manager}
                                    onChange={(value) =>
                                      handleSelectChangereleaseManagers(
                                        "pr_third_release_manager",
                                        value
                                      )
                                    }
                                    disabled={!state.editableFlag2}
                                    optionFilterProp="children"
                                  >
                                    {releaseManagers.map((managers) => (
                                      <option
                                        key={managers.user_id}
                                        value={managers.user_id}
                                        disabled={selectedReleaseManager?.includes(
                                          managers.user_id
                                        )}
                                      >
                                        {managers?.first_name
                                          ?.charAt(0)
                                          ?.toUpperCase() +
                                          managers?.first_name
                                            ?.slice(1)
                                            ?.toLowerCase()}
                                      </option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <>
                                {/* <Col span={5} className="TextFeild gutter-row">
                                  <Form.Item name="designation2">
                                    <Input
                                      placeholder="HOD"
                                      value={designation2}
                                      disabled
                                    />
                                  </Form.Item>
                                </Col> */}
                                <Col span={5} className="TextFeild gutter-row">
                                  <Form.Item name="phone2">
                                    <PhoneInput
                                      country={"in"}
                                      className="PhoneSection"
                                      inputProps={{ readOnly: true }}
                                      disabled
                                      value={phone2} // Assuming you're targeting index 0
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={6} className="TextFeild gutter-row">
                                  {/* <Form.Item name="role"> */}
                                  <div className="verifywrap">
                                    <div>
                                      <Select
                                        mode="multiple"
                                        maxTagCount="responsive"
                                        style={{ width: "250px" }}
                                        placeholder="Role"
                                        // disabled
                                        value={role2}
                                        tagRender={({ label }) => (
                                          <span
                                            style={{
                                              padding: "4px 5px",
                                              background: "#f0f0f0",
                                              borderRadius: "4px",
                                              marginRight: "5px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            {label}
                                          </span>
                                        )}
                                      >
                                        {role2?.map((vendor) => (
                                          <Select.Option
                                            key={vendor}
                                            value={vendor}
                                          >
                                            {vendor}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </div>

                                    {/* <InputField
                                      name="role1"
                                      placeholder={t("Role")}
                                      // max={40}
                                      disabled
                                    /> */}
                                  </div>
                                  {/* </Form.Item> */}
                                </Col>
                              </>
                            </Row>
                            <Row gutter={16}>
                              <Col span={4}>
                                <Checkbox
                                  checked={state.pr_fourth_release} // Set the checked status based on state
                                  disabled={!editableFlagThirdPRRelease}
                                  onChange={(e) => {
                                    handleCheckBox4(
                                      "pr_fourth_release",
                                      e.target.checked,
                                      state.pr_fourth_release_manager
                                    );
                                    // setSelectedForthReleaseManager(e)
                                  }}
                                >
                                  Forth Release
                                </Checkbox>
                              </Col>
                              <Col span={4} className="TextFeild gutter-row">
                                <Form.Item
                                  name="pr_fourth_value_up_to"
                                  rules={[
                                    {
                                      required: state.pr_fourth_release,
                                      message: (
                                        <Trans>
                                          {" "}
                                          Please Enter PR Forth Value Up To
                                        </Trans>
                                      ),
                                      validator: (_, value) => {
                                        const parsedValue = parseFloat(value);
                                        if (state.pr_fourth_release) {
                                          // If checkbox is checked, don't allow 0
                                          if (
                                            !isNaN(parsedValue) &&
                                            parsedValue !== 0
                                          ) {
                                            return Promise.resolve();
                                          }
                                          return Promise.reject(
                                            new Error("Value cannot be 0")
                                          );
                                        } else {
                                          // If checkbox is unchecked, allow any value
                                          return Promise.resolve();
                                        }
                                      },
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="5,000"
                                    addonBefore={currencySymbol}
                                    type="number"
                                    value={state.pr_fourth_value_up_to}
                                    onChange={(e) =>
                                      handlePoReleaseChange(
                                        "pr_fourth_value_up_to",
                                        e.target.value
                                      )
                                    }
                                    disabled={!state.editableFlag4}
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={4}>
                                <Form.Item
                                  name="pr_fourth_release_manager"
                                  prefix={<ZipCode />}
                                  rules={[
                                    {
                                      required: state.pr_fourth_release,
                                      message: (
                                        <Trans>
                                          {" "}
                                          Please Enter PR Forth Release Manager
                                        </Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <Select
                                    showArrow
                                    showSearch
                                    allowClear
                                    placeholder="Select Release Manager"
                                    value={state.pr_fourth_release_manager}
                                    onChange={(value) =>
                                      handleSelectChangereleaseManagers4(
                                        "pr_fourth_release_manager",
                                        value
                                      )
                                    }
                                    disabled={!state.editableFlag4}
                                    optionFilterProp="children"
                                  >
                                    {releaseManager4.map((managers4) => (
                                      <Option
                                        key={managers4.user_id}
                                        value={managers4.user_id}
                                        disabled={selectedReleaseManager?.includes(
                                          managers4.id
                                        )}
                                      >
                                        {managers4?.first_name
                                          ?.charAt(0)
                                          ?.toUpperCase() +
                                          managers4?.first_name
                                            ?.slice(1)
                                            ?.toLowerCase()}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <>
                                {/* <Col span={5} className="TextFeild gutter-row">
                                  <Form.Item name="designation3">
                                    <Input
                                      placeholder="HOD"
                                      value={designation3}
                                      disabled
                                    />
                                  </Form.Item>
                                </Col> */}
                                <Col span={5} className="TextFeild gutter-row">
                                  <Form.Item name="phone3">
                                    <PhoneInput
                                      country={"in"}
                                      className="PhoneSection"
                                      value={phone3}
                                      inputProps={{ readOnly: true }}
                                      disabled
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={6} className="TextFeild gutter-row">
                                  {/* <Form.Item name="role"> */}
                                  <div className="verifywrap">
                                    <div>
                                      <Select
                                        mode="multiple"
                                        maxTagCount="responsive"
                                        style={{ width: "250px" }}
                                        placeholder="Role"
                                        // disabled
                                        value={role3}
                                        tagRender={({ label }) => (
                                          <span
                                            style={{
                                              padding: "4px 5px",
                                              background: "#f0f0f0",
                                              borderRadius: "4px",
                                              marginRight: "5px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            {label}
                                          </span>
                                        )}
                                      >
                                        {role3?.map((vendor) => (
                                          <Select.Option
                                            key={vendor}
                                            value={vendor}
                                          >
                                            {vendor}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </div>

                                    {/* <InputField
                                      name="role1"
                                      placeholder={t("Role")}
                                      // max={40}
                                      disabled
                                    /> */}
                                  </div>
                                  {/* </Form.Item> */}
                                </Col>
                              </>
                            </Row>
                            <Row gutter={16}>
                              <Col span={4}>
                                <Checkbox
                                  checked={state.pr_fifth_release} // Set the checked status based on state
                                  disabled={!editableFlagFourthPRRelease}
                                  onChange={(e) =>
                                    handleCheckBox5(
                                      "pr_fifth_release",
                                      e.target.checked,
                                      state.pr_fifth_release_manager
                                    )
                                  }
                                >
                                  Fifth Release
                                </Checkbox>
                              </Col>
                              <Col span={4} className="TextFeild gutter-row">
                                <Form.Item
                                  name="pr_fifth_value_up_to"
                                  rules={[
                                    {
                                      required: state.pr_fifth_release,
                                      message: (
                                        <Trans>
                                          {" "}
                                          Please Enter PR Fifth Value Up To
                                        </Trans>
                                      ),
                                      validator: (_, value) => {
                                        const parsedValue = parseFloat(value);
                                        if (state.pr_fifth_release) {
                                          // If checkbox is checked, don't allow 0
                                          if (
                                            !isNaN(parsedValue) &&
                                            parsedValue !== 0
                                          ) {
                                            return Promise.resolve();
                                          }
                                          return Promise.reject(
                                            new Error("Value cannot be 0")
                                          );
                                        } else {
                                          // If checkbox is unchecked, allow any value
                                          return Promise.resolve();
                                        }
                                      },
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="5,000"
                                    addonBefore={currencySymbol}
                                    type="number"
                                    value={state.pr_fifth_value_up_to}
                                    onChange={(e) =>
                                      handlePoReleaseChange(
                                        "pr_fifth_value_up_to",
                                        e.target.value
                                      )
                                    }
                                    disabled={!state.editableFlag5}
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={4}>
                                <Form.Item
                                  name="pr_fifth_release_manager"
                                  prefix={<ZipCode />}
                                  rules={[
                                    {
                                      required: state.pr_fifth_release,
                                      message: (
                                        <Trans>
                                          {" "}
                                          Please Enter PR Fifth Release Manager
                                        </Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <Select
                                    showArrow
                                    showSearch
                                    allowClear
                                    placeholder="Select Release Manager"
                                    value={state.pr_fifth_release_manager}
                                    onChange={(value) =>
                                      handleSelectChangereleaseManagers5(
                                        "pr_fifth_release_manager",
                                        value
                                      )
                                    }
                                    disabled={!state.editableFlag5}
                                    optionFilterProp="children"
                                  >
                                    {releaseManager5.map((managers5) => (
                                      <Option
                                        key={managers5.user_id}
                                        value={managers5.user_id}
                                        disabled={selectedReleaseManager?.includes(
                                          managers5.user_id
                                        )}
                                      >
                                        {managers5?.first_name
                                          ?.charAt(0)
                                          ?.toUpperCase() +
                                          managers5?.first_name
                                            ?.slice(1)
                                            ?.toLowerCase()}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <>
                                {/* <Col span={5} className="TextFeild gutter-row">
                                  <Form.Item name="designation4">
                                    <Input
                                      placeholder="HOD"
                                      value={designation4}
                                      disabled
                                    />
                                  </Form.Item>
                                </Col> */}
                                <Col span={5} className="TextFeild gutter-row">
                                  <Form.Item name="phone4">
                                    <PhoneInput
                                      country={"in"}
                                      className="PhoneSection"
                                      inputProps={{ readOnly: true }}
                                      disabled
                                      value={phone4} // Assuming you're targeting index 0
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={6} className="TextFeild gutter-row">
                                  {/* <Form.Item name="role"> */}
                                  <div className="verifywrap">
                                    <div>
                                      <Select
                                        mode="multiple"
                                        maxTagCount="responsive"
                                        style={{ width: "250px" }}
                                        placeholder="Role"
                                        // disabled
                                        value={role4}
                                        tagRender={({ label }) => (
                                          <span
                                            style={{
                                              padding: "4px 5px",
                                              background: "#f0f0f0",
                                              borderRadius: "4px",
                                              marginRight: "5px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            {label}
                                          </span>
                                        )}
                                      >
                                        {role4?.map((vendor) => (
                                          <Select.Option
                                            key={vendor}
                                            value={vendor}
                                          >
                                            {vendor}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </div>

                                    {/* <InputField
                                      name="role1"
                                      placeholder={t("Role")}
                                      // max={40}
                                      disabled
                                    /> */}
                                  </div>
                                  {/* </Form.Item> */}
                                </Col>
                              </>
                            </Row>
                          </>
                        )}
                      </div></div>
                    </div>
                  </div>
                  </Spin>
                </div>
                <div className="stepsFooter">
                  <Button
                    cursor="pointer"
                    type="secondary"
                    className="primary"
                    onClick={() => navigate("/pr-approval-heirarchy-list")}
                  >
                    Cancel
                  </Button>
                  {/* {formValid && */}
                  {/* { formValid && ( */}
                  <Button
                    cursor="pointer"
                    type="primary"
                    className="primary"
                    htmlType="Submit"
                    label={t("save")}
                    loading={btnLoading}
                    //disabled={!formValid}
                  >
                    Save
                  </Button>
                  {/* ) } */}
                </div>
                  </Form>
         
           </div></section>
          
   
    </>
  );
};

export default PRApprovalHierarchy;
